import axios, { AxiosResponse } from 'axios';
import {
  TTradingPlatform,
  TTradingPlatformsRes,
  TTradingPlatformQuery,
} from '@src/types';

export const getTradingPlatforms = (
  params?: TTradingPlatformQuery
): Promise<AxiosResponse<TTradingPlatformsRes>> => {
  return axios.get(`trading-platforms/`, { params: { ...params, size: 20 } });
};

export const getAllTradingPlatforms = (): Promise<
  AxiosResponse<TTradingPlatform[]>
> => {
  return axios.get(`trading-platforms/all/`);
};

export const saveTradingPlatform = (
  data: TTradingPlatform
): Promise<AxiosResponse<TTradingPlatform>> => {
  return axios.post(`trading-platforms/`, data);
};

export const getTradingPlatformDetail = (
  id: number
): Promise<AxiosResponse<TTradingPlatform>> => {
  return axios.get(`trading-platforms/${id}/`);
};
